import { useServiceName } from '@consigli/hooks';
import { ServiceName } from '@consigli/types';

import { CeilingViewerProvider } from '@/features/ceiling-viewer/ceiling-viewer-context';

import { BidReviewWizard } from './bid-review/bid-review-wizard';
import { CeilingWizard } from './ceiling/ceiling-wizard';
import { ComparisonWizard } from './comparison/comparison-wizard';
import { StructuralForm } from './components/user-input';
import { InsightWizard } from './insight/insight-wizard';
import { LoadCalculationWizard } from './load-calculation/load-calculation-wizard';
import { LuminaireScheduleWizard } from './luminaire-schedule/luminaire-schedule-wizard';
import { OptimizationWizard } from './optimization/optimization-wizard';
import { QaAgentWizard } from './qa-agent/qa-agent-wizard';
import { ReportGenerationWizard } from './reports/report-generation-wizard';
import { ScheduleCheckWizard } from './schedule-check/schedule-check-wizard';
import { SiteDueDiligenceWizard } from './site-due-diligence/site-due-diligence-wizard';
import { SpaceAnalysisWizard } from './space-analysis/space-analysis-wizard';
import { StructuralWizard } from './structural/structural-wizard';
import { VersionCompareWizard } from './version-compare/version-compare-wizard';
import { WaterProcessSystemsAgentWizard } from './water-process-systems-agent/water-process-systems-agent-wizard';

export const WizardWrapper = () => {
  const serviceName = useServiceName();
  if (
    serviceName === ServiceName.PLANT_ROOM ||
    serviceName === ServiceName.CEILING_PLAN ||
    serviceName === ServiceName.FLOOR_PLAN ||
    serviceName === ServiceName.PARKING ||
    serviceName === ServiceName.REPORTS
  ) {
    return <OptimizationWizard />;
  } else if (serviceName === ServiceName.REPORT_GENERATION) {
    return <ReportGenerationWizard />;
  } else if (serviceName === ServiceName.BID_REVIEW) {
    return <BidReviewWizard />;
  } else if (serviceName === ServiceName.TENANT_REQUIREMENTS || serviceName === ServiceName.OFFER) {
    return <ComparisonWizard />;
  } else if (serviceName === ServiceName.CEILING_GRID) {
    return (
      <CeilingViewerProvider>
        <CeilingWizard />
      </CeilingViewerProvider>
    );
  } else if (serviceName === ServiceName.LOAD_CALCULATION) {
    return <LoadCalculationWizard />;
  } else if (serviceName === ServiceName.LUMINAIRE_SCHEDULE) {
    return <LuminaireScheduleWizard />;
  } else if (serviceName === ServiceName.STRUCTURAL) {
    return <StructuralWizard userInput={<StructuralForm></StructuralForm>} />;
  } else if (serviceName === ServiceName.SCHEDULE_CHECK) {
    return <ScheduleCheckWizard />;
  } else if (serviceName === ServiceName.SPACE_ANALYSIS) {
    return <SpaceAnalysisWizard />;
  } else if (serviceName === ServiceName.SITE_DUE_DILIGENCE) {
    return <SiteDueDiligenceWizard />;
  } else if (serviceName === ServiceName.QA_AGENT) {
    return <QaAgentWizard />;
  } else if (serviceName === ServiceName.VERSION_COMPARE) {
    return <VersionCompareWizard />;
  } else if (serviceName === ServiceName.WATER_PROCESS_SYSTEMS_AGENT) {
    return <WaterProcessSystemsAgentWizard />;
  } else {
    return <InsightWizard></InsightWizard>;
  }
};
